import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { Route, useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';
import { BrowserView, MobileView } from 'react-device-detect';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Alert, Badge, Button, Card, Col, Form, InputGroup, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';

import Paginacao from '../../../Componentes/Paginacao';

import Registro from './Registro';
import ModalFiltros from './ModalFiltros';
import ModalVisualizarEnderecoPesquisa from './ModalVisualizarEnderecoPesquisa'
import { ListaEnderecosPesquisaComponent } from "./components";
import moment from 'moment';

export default function ListaEnderecosPesquisa({
    
}){

    // pega location
    const history = useHistory();
    const location = useLocation();
    let { path, url } = useRouteMatch();

    // parametros da url
    const {
        // idEmpresa = null
    } = useParams();

    // estados
    const [ carregando, alterarCarregando ] = useState(null);
    const [ mostrarFiltros, alterarMostrarFiltros ] = useState(false);
    const [ parametros, alterarParametros ] = useState({
        registrosPorPagina: 8,
        pagina: 1,
        pesquisa: null,
        dataInicio: moment().format(`YYYY-MM-DD`)
    });
    const [ registros, alterarRegistros ] = useState([]);
    const [ totalRegistros, alterarTotalRegistros ] = useState(null);
    const [ erros, alterarErros ] = useState({});
    const [ registroMostrarDados, alterarRegistroMostrarDados ] = useState(null);
    const refAbrirFiltros = useRef(null);

    // prepara
    const pathsConsultar = [
        '/painel/enderecos',
        '/painel/enderecos/pesquisas'
    ];

    // efeitos

    useEffect(() => {

        // verifica se é o path
        if(pathsConsultar.includes(location.pathname)){

            // consulta registros
            consultar();
        }

    }, [parametros]);

    useEffect(() => {

        // pega
        let {
            aPartirDe
        } = location.state ?? {};

        console.log({carregando, aPartirDe})
        // se retornar a essa rota
        if(carregando !== null && pathsConsultar.includes(location.pathname) && (!aPartirDe || !['visualizarEnderecoPesquisa'].includes(aPartirDe))){

            // consulta
            consultar();
        }

    }, [location.pathname]);

    // função para consultar
    async function consultar(){

        // cria o carregamento
        alterarCarregando(true);

        try{

            // consulta
            let { data } = await axios.get(`/enderecos/pesquisas`, {
                params: {
                    ...parametros
                }
            });

            // sucesso

            // pega os registros e total
            alterarRegistros(data.registros);
            alterarTotalRegistros(data.totalRegistros);

        }catch(e){
            // erro

            // pega a resposta
            let response = e.response;
            // console.log(e);

            // verifica se tem a resposta
            if(response){

                // verifica se é erro 404
                if(response.status === 404){

                    // informa erro
                    toast(<>
                        <div
                            style={{background: '#ff6271'}}
                        >
                            <div className="toast-header">
                                <strong className="mr-auto">Empresa desatualizada</strong>
                                <button 
                                    className="ml-2 mb-1 close btn-outline-light outline-0"
                                >
                                </button>
                            </div>
                            <div className="toast-body text-light">
                                A empresa não possui a versão com a consulta de logs da API.
                            </div>
                        </div>
                    </>);

                    // define o erro
                    alterarErros({
                        semApi: `A empresa não possui a versão com a consulta de logs da API.`
                    });
                }
            }

        }finally{
            // finalizou

            // remove o carregamento
            alterarCarregando(false);
        }
    }

    // retorna registro
    function retornaRegistros(){

        // retorna registros organizado
        return registros.map((registro, indice) => 
            <Registro
                key={registro.dados.id}
                dados={registro.dados}
                encontradoEm={registro.encontradoEm}
                dataAnterior={indice > 0 ? registros[indice - 1].dados.dataCadastro : null}
                dadosEmpresa={registro.dadosEmpresa}
                dadosUsuario={registro.dadosUsuario}
                clicouAbrir={() => {

                    // verifica a url
                    let urlPesquisas = `${url}${url.includes('/pesquisas') ? '' : '/pesquisas'}`;
                    
                    // vai na edição
                    history.push(`${urlPesquisas}/${registro.dados.id}`);
                }}
            />
        )
    }

    return <ListaEnderecosPesquisaComponent>
        <ModalFiltros
            elemento={refAbrirFiltros.current}
            mostrar={mostrarFiltros}
            alterarMostrar={alterarMostrarFiltros}
            parametros={parametros}
            alterarParametros={alterarParametros}
        />
        {/* <Card.Body> */}
            <Card.Header className={'px-0'}>
                <div className={'d-flex '}>
                    <Card.Title className={'flex-grow-1 d-flex align-items-center mb-0'}>
                        Pesquisas
                    </Card.Title>
                    
                    <div>
                        <Button
                            variant='light'
                            size='sm'
                            ref={refAbrirFiltros}
                            onClick={() => {

                                // define
                                alterarMostrarFiltros(true);
                            }}
                            style={{
                                fontSize: '0.9em',
                                boxShadow: '0 0 1px #b1b1b1',
                                border: 0,
                                display: 'flex',
                                gap: '0.2em',
                                alignItems: 'center'
                            }}
                        >
                            <FontAwesomeIcon className="icone" icon={faFilter} />
                            Filtrar
                        </Button>
                    </div>
                </div>
            </Card.Header>
            <div>
                {
                carregando ? <div className="p-5 text-center">
                    <FontAwesomeIcon icon={faSpinner} pulse /> Carregando...
                </div> : (
                        <div
                            className={'position-relative my-2'}
                        >
                            <table className='tabela'>
                                {totalRegistros > 0 && <tbody>
                                    { retornaRegistros() }
                                </tbody>}
                            </table>
                
                            {
                                Object.keys(erros).map((erro) => {
                                    return <Alert
                                        key={erro}
                                        className={['alerta', 'my-1'].join(' ')}
                                        dismissible
                                        onClose={() => alterarErros({})}
                                        variant="danger"
                                    >
                                        <p>{erros[erro]}</p>
                                    </Alert>
                                })
                            }
                        </div>
                    )
                }
                
                <Paginacao
                    pagina={parametros.pagina}
                    registrosPorPagina={parametros.registrosPorPagina}
                    totalRegistros={totalRegistros}
                    alterouPagina={(pagina) => {
                        alterarParametros({...parametros, pagina: pagina});
                    }}
                />

                <div className='legenda'>
                    <div className='interno'>Base interna</div>
                    <div className='retornoReutilizado'>Retorno reutilizado</div>
                    <div className='google'>Google</div>
                    <div className='nao-encontrado'>Não encontrado</div>
                </div>
            </div>
        {/* </Card.Body> */}

        {/* modal para informações da requisição */}
        <Route exact path={[
            '/painel/enderecos/pesquisas/:id'
        ]}>
            <ModalVisualizarEnderecoPesquisa />
        </Route>
        {/* <PainelVisualizarEnderecoPesquisa
            mostrar={!!registroMostrarDados}
            fechar={() => {

                // fecha
                alterarRegistroMostrarDados(null); 
            }}
            {...(registroMostrarDados ?? {})}
        /> */}
    </ListaEnderecosPesquisaComponent>
    
}